import { render, staticRenderFns, recyclableRender, components } from "./searchProduct.vue?vue&type=template&id=694d657c&"
var renderjs
import script from "./searchProduct.vue?vue&type=script&lang=js&"
export * from "./searchProduct.vue?vue&type=script&lang=js&"
import style0 from "./searchProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/searchProduct.vue"
export default component.exports